'use client';

import { useEffect } from 'react';

/**
 * Global tracker for tel: link clicks.
 * Uses event delegation — catches ALL tel: links on the page,
 * including dynamically added ones, without modifying individual components.
 *
 * Events appear in GA4 as "phone_click" with page_path and link_text.
 */
export function PhoneClickTracker() {
  useEffect(() => {
    function handleClick(e: MouseEvent) {
      const anchor = (e.target as HTMLElement).closest?.('a[href^="tel:"]') as HTMLAnchorElement | null;
      if (!anchor) return;

      const phone = anchor.href.replace('tel:', '');
      const text = anchor.textContent?.trim() || '';
      const page = window.location.pathname;

      if (typeof window.gtag === 'function') {
        window.gtag('event', 'phone_click', {
          event_category: 'contact',
          event_label: text,
          phone_number: phone,
          page_path: page,
        });
      }
    }

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);

  return null;
}
